import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import type {
  Partners,
  PartnersTemplateFour,
} from 'hb-builder/components/BuilderComponents/block/Partners/types/items';
import DragAndDropList from 'hb-builder/components/common/DragAndDropList';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import type { OnChangeSetting } from 'hb-builder/types/settings';

import AddPartnerButton from './AddPartnerButton';
import ContentItem from './ContentItem';
import Headline from './ContentItem/Headline';

interface ContentProps {
  item: Partners | PartnersTemplateFour;
  onChange: OnChangeSetting;
}
const Content = ({ item, onChange }: ContentProps) => {
  const [column1, column2] = item.children || [];
  const [headline] = column1.children || [];

  const templateFour = item.name === 'PartnersTemplateFour';
  const partnersBlock = templateFour
    ? column2?.children?.[0]
    : column1.children?.[1];

  const handleChange: OnChangeSetting = ({ id, settingKey, value }) => {
    if (partnersBlock) {
      onChange({
        id: partnersBlock.id,
        settingKey: 'attributes.containerPadding',
        value: value ? '0px 0px 0px 0px' : '60px 0px 0px 0px',
      });
    }

    onChange({
      id,
      settingKey,
      value,
    });
  };

  return (
    <Wrapper>
      <AccordionTitle isInitiallyOpen title={__('Headline')}>
        <Headline
          headline={headline}
          onChange={onChange}
          handleChange={handleChange}
        />
      </AccordionTitle>
      {partnersBlock && (
        // @ts-expect-error not typed
        <DragAndDropList
          childrenComponent={ContentItem}
          componentName="Logo"
          item={partnersBlock}
          listButton={<AddPartnerButton item={partnersBlock} />}
          onChange={onChange}
          selectedChildParentItem={item}
        />
      )}
    </Wrapper>
  );
};

export default Content;

const Wrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  width: '100%',
}))``;
